import type { PixelEvent } from '@/events';

export type DestinationPipelineStage = {
  readonly name: string;
  process(event: PixelEvent): PixelEvent | null;
};

/**
 * Optional internal pipeline for destinations / engine ingress.
 * Stages compose; PixelEvent is never mutated in place — stages return new or same reference.
 */
export class DestinationPipeline {
  private readonly stages: readonly DestinationPipelineStage[];

  private lastSteps: string[] = [];

  constructor(stages: readonly DestinationPipelineStage[] = []) {
    this.stages = stages;
  }

  static identity(): DestinationPipeline {
    return new DestinationPipeline([
      {
        name: 'identity',
        process(event) {
          return event;
        },
      },
    ]);
  }

  process(event: PixelEvent): PixelEvent | null {
    const steps: string[] = [];
    let current: PixelEvent | null = event;

    for (const stage of this.stages) {
      steps.push(stage.name);
      if (!current) break;
      current = stage.process(current);
    }

    this.lastSteps = steps;
    return current;
  }

  getLastSteps(): readonly string[] {
    return this.lastSteps;
  }
}
